var actions = {
	next: "Další",
	confirm: "Potvrdit",
	"continue": "Pokračovat"
};
var errors = {
	unknown: "Vyskytla se neznámá chyba",
	contactSupport: "Vyskytla se chyba. Kontaktujte podporu.",
	tryAgain: "Vyskytla se chyba. Zkuste to znovu.",
	submit: "Došlo k chybě s vaším odesláním."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Přihlásit se pomocí {name}",
	signupWith: "Registrovat se pomocí {name}"
};
var alreadyHaveAccount = {
	company: "Máte již účet {company}?",
	text: "Máte již Streamlabs ID?",
	link: "Přihlásit"
};
var noAccount = {
	text: "Ještě nemáte účet?",
	link: "Registrovat"
};
var validation = {
	email: {
		invalid: "Zadejte platnou e-mailovou adresu"
	},
	password: {
		required: "Vyžadováno heslo",
		min: "Heslo musí mít délku alespoň 8 znaků",
		number: "Heslo musí obsahovat číslo",
		upper: "Heslo musí obsahovat velké písmeno",
		special: "Heslo musí mít zvláštní znak"
	},
	username: {
		invalid: "Heslo musí mít alespoň 5 znaků"
	},
	code: {
		minmax: "Heslo musí obsahovat 6 - 10 znaků"
	}
};
var poweredBy = "Používá technologii <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Stránka nenalezena!",
		desc: "Zkuste to znovu později nebo kontaktujte podporu."
	},
	company: {
		logoAlt: "{company} Logo"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6místný autorizační kód/8místný záložní kód",
	successText: "Povedlo se! Přesměrovávání...",
	remember: "Zapamatovat si toto zařízení po dobu 30 dnů"
};
var createTfa = {
	scan: {
		title: "Povolit dvoufaktorové ověření",
		lead: "Klikněte/zkopírujte nebo naskenujte níže uvedený kód pomocí preferované ověřovací aplikace. K bezpečnému ukládání kódů doporučujeme používat aplikaci, jako například <app0 />, <app1 /> nebo <app2 />.",
		copied: "Zkopírováno!",
		instructions: "Nebo ručně zadejte tento kód do ověřovací aplikace.",
		copy: "Kopírovat kód",
		proceed: "Potvrzení"
	},
	confirm: {
		title: "Potvrďte vaše dvoufaktorové ověření",
		lead: "Odešlete níže vygenerovaný kód 2FA pro potvrzení a povolte dvoufaktorové ověření.",
		label: "Kód 2faktorového ověření (6 číslic)",
		verify: "Ověřit kód",
		next: "Povedlo se! Další krok"
	},
	save: {
		title: "Uložte si kódy pro obnovu",
		lead: "Uložte si své následující kódy pro obnovu pro případ, že ztratíte přístup ke svému dvoufaktorovému autentizátoru. Po ukončení tohoto režimu tyto kódy již nebudou dostupné.",
		label: "Kódy pro obnovu",
		download: "Stáhnout kódy pro obnovu",
		copied: "Kódy byly zkopírovány!",
		finished: "Dokončeno"
	}
};
var emailLoginForm = {
	buttonText: "Přihlásit",
	emailPlaceholder: "E-mailem",
	passwordPlaceholder: "Heslo"
};
var emailSignupForm = {
	buttonText: "Registrovat",
	emailPlaceholder: "Nastavit e-mail",
	passwordPlaceholder: "Nastavit heslo",
	usernamePlaceholder: "Vaše jméno",
	ageLabel: "Datum narození",
	agePlaceholder: "MM/DD/RRRR",
	agreeText: "Souhlasím s <terms>Podmínkami služby</terms> a <privacy>Zásadami ochrany osobních údajů</privacy> Streamlabs.",
	agreeError: "Přijměte smluvní podmínky Streamlabs"
};
var ageInput = {
	invalidDate: "Zadejte platné datum narození",
	futureDate: "Datum narození se musí nacházet v minulosti",
	minDate: "Data před rokem {year} nejsou povolena",
	minAge_one: "Abyste mohli používat Streamlabs, musí vám být {years} nebo více let",
	minAge_two: "Abyste mohli používat Streamlabs, musí vám být {years} nebo více let",
	minAge_other: "Abyste mohli používat Streamlabs, musí vám být {years} nebo více let"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mailem",
	back: "Zpět na přihlášení",
	successText: "Povedlo se! Zaslali jsme vám kód pro obnovení hesla",
	buttonText: "Požádat o obnovení e-mailu",
	create: {
		successText: "Povedlo se! Odeslali jsme vám ověřovací kód, abyste mohli začít.",
		buttonText: "Vyžádat ověřovací kód"
	},
	errors: {
		notFound: "Nebyl nalezen žádný účet s touto e-mailovou adresou"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Zapomněli jste své heslo?",
	lead: "Pokud potřebujete resetovat vaše heslo, zadejte níže váš e-mail a my vám zašleme e-mail pro zahájení procesu.",
	resetTitle: "Resetovat své heslo",
	resetLead: "Již jste měli obdržet kód e-mailem. Vyplňte formulář pro obnovení hesla.",
	create: {
		title: "Vytvořte si heslo",
		lead: "Blahopřejeme vám k vytvoření vašeho ID Streamlabs! Ještě jeden krok a budete se moci přihlásit napříč všemi platformami Streamlabs!",
		resetTitle: "Vyberte heslo",
		resetLead: "Již jste měli obdržet kód e-mailem. Použijte jej a vyplňte formulář pro nastavení hesla."
	},
	successText: "Povedlo se! Přesměrovávání...",
	signInTitle: "Máte již účet?",
	signInBtn: "Přihlásit"
};
var checkTfaCard = {
	title: "Kontrola dvoufaktorového ověření",
	lead: "Pokračujte zadáním kódu 2faktorového ověření níže.",
	successText: "2FA úspěšně potvrzeno!",
	back: "Přejít zpět"
};
var verifyEmailCard = {
	title: "Ověřte váš e-mail",
	lead: "Ve vašem e-mailu vyhledejte 8místný kód od Streamlabs a zadejte jej níže.",
	back: "Přejít zpět",
	successText: "E-mail byl úspěšně ověřen!"
};
var upgradeCard = {
	confirm: {
		title: "Potvrďte připojení {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Když budete pokračovat, budete se moci přihlásit k {company} pomocí e-mailové adresy a poskytnutého hesla.",
			"Můžete přistupovat ke všem ostatním produktům od společnosti Streamlabs pomocí vašeho ID a připojit další existující účty (pokud nějaké máte).",
			"Váš účet {company} nebude touto změnou nijak omezen."
		],
		button: "Potvrdit",
		cancel: "Zrušit",
		switchAccount: "Přepnout účet",
		success: "Připojování..."
	},
	confirmed: {
		title: "Povedlo se!",
		subtitle: "Bylo vytvořeno vaše Streamlabs ID a účet {company} je připojen.",
		text: "Vaše Streamlabs ID můžete používat pro všechny produkty Streamlabs. Máte-li existující účty, můžete je připojit k tomuto ID z jednotlivých aplikací.",
		button: "Zavřít"
	},
	error: {
		user: "Identifikace uživatele se nezdařila. Zkuste se přihlásit znovu později nebo kontaktujte podporu."
	}
};
var confirmCard = {
	confirm: {
		title: "Potvrďte připojení {company}",
		subtitle: "Našli jsme účet s odpovídající e-mailovou adresou. Chcete sloučit tento účet se Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Budete se moci přihlásit k {company} pomocí e-mailu a hesla, které jste poskytli prostřednictvím Streamlabs ID.",
			"Můžete přistupovat ke všem ostatním produktům od společnosti Streamlabs pomocí svého ID a připojit další existující účty (pokud nějaké máte).",
			"Tato změna nebude mít vliv na váš firemní účet."
		],
		button: "Potvrdit",
		cancel: "Zrušit",
		switchAccount: "Přepnout účet",
		success: "Připojování..."
	},
	confirmed: {
		title: "Povedlo se!",
		subtitle: "Bylo vytvořeno vaše Streamlabs ID a účet {company} je připojen.",
		text: "Vaše Streamlabs ID můžete používat pro všechny produkty Streamlabs. Máte-li existující účty, můžete je připojit k tomuto ID z jednotlivých aplikací.",
		button: "Zavřít"
	},
	error: {
		user: "Identifikace uživatele se nezdařila. Zkuste se přihlásit znovu nebo kontaktujte podporu."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " K vašemu ID je již připojen účet {company}.",
		subtitle: "Chcete odpojit připojený účet a připojit se k aktuálnímu účtu Streamlabs?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Do Streamlabs se budete moci přihlásit pomocí e-mailu a hesla, které jste zadali pro Streamlabs ID.",
			"Můžete přistupovat ke všem ostatním produktům od společnosti Streamlabs pomocí svého ID a připojit další existující účty (pokud nějaké máte).",
			"Tato změna nebude mít vliv na váš účet Streamlabs."
		],
		button: "Potvrdit",
		cancel: "Zrušit",
		switchAccount: "Přepnout účet",
		success: "Připojování...",
		agreeLabel: "Beru na vědomí, že tímto připojením ztratím přístup ke stávajícímu účtu {company}, který je vázán na Streamlabs ID."
	},
	confirmed: {
		title: "Povedlo se!",
		subtitle: "Bylo vytvořeno vaše Streamlabs ID a účet {company} je připojen.",
		text: "Vaše Streamlabs ID můžete používat pro všechny produkty Streamlabs. Máte-li existující účty, můžete je připojit k tomuto ID z jednotlivých aplikací.",
		button: "Zavřít"
	},
	error: {
		user: "Identifikace uživatele se nezdařila. Zkuste se přihlásit znovu nebo kontaktujte podporu."
	}
};
var loginCard = {
	title: "Přihlásit",
	lead: "Přihlaste se k <company>{company}</company> pomocí <id>Streamlabs ID</id>",
	accountExists: "Pravděpodobně máte <b>Streamlabs ID</b>. Zkuste se přihlásit pomocí vašeho e-mailu.",
	forgotPassword: "Zapomněli jste heslo?",
	successText: "Povedlo se! Přesměrovávání...",
	signInTitle: "Přihlásit se pomocí platformy"
};
var loginSourcesCard = {
	title: "Přihlásit",
	lead: "Přihlásit se pomocí e-mailu/hesla",
	withSlId: "Přihlásit se pomocí Streamlabs ID",
	noAccountMessage: "Nemůžeme najít účet spojený s tímto způsobem přihlášení. Zkuste jiný způsob přihlášení nebo proveďte <signup>Registrace</signup>, pokud jste tak dosud neučinili.",
	accountExistsMessage: "Vaše e-mailová adresa Twitch je již přidružena ke Streamlabs. Zkuste se přihlásit pomocí e-mailu a hesla Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mailem",
	codePlaceholder: "6 - 8místný e-mailový kód",
	tfaCodePlaceholder: "Kód 2FAuthenticator",
	newPasswordPlaceholder: "Nové heslo",
	tfaError: "Heslo musí mít délku 6 - 10 znaků.",
	next: "Obdrželi jste kód?",
	back: "Zpět na Zapomenuté heslo",
	buttonText: "Změnit heslo",
	successText: "Heslo bylo úspěšně obnoveno",
	create: {
		back: "Zpět na začátek",
		buttonText: "Nastavit heslo",
		successText: "Heslo nastaveno úspěšně"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Aktuální heslo",
	newPasswordPlaceholder: "Nové heslo",
	newPasswordConfirmationPlaceholder: "Potvrdit nové heslo",
	buttonText: "Změnit heslo",
	successText: "Heslo bylo úspěšně zaktualizováno",
	newPasswordConfirmationError: "Hesla se neshodují",
	back: "Zpět na řídicí panel"
};
var changePasswordCard = {
	title: "Změňte vaše heslo",
	lead: "Níže zadejte své aktuální heslo spolu s novým heslem.",
	successText: "Heslo bylo úspěšně zaktualizováno"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6místný autorizační kód/8místný záložní kód",
	successText: "2FA bylo úspěšně odebráno",
	removeBtn: "Potvrdit a odebrat"
};
var removeTfaCard = {
	title: "Odebrat dvoufaktorové ověření",
	lead: "Níže zadejte potvrzovací kód 2FA pro odstranění dvoufaktorového ověření z vašeho účtu.",
	successText: "2FA bylo úspěšně odebráno",
	back: "Zpět na řídicí panel"
};
var verifyEmailForm = {
	codePlaceholder: "8místný kód z e-mailu",
	tfaCodePlaceholder: "Kód 2FAuthenticator",
	emailPlaceholder: "E-mailová adresa",
	buttonText: "Ověřit e-mail",
	successText: "E-mail byl úspěšně ověřen",
	requestBtn: "Požádat o nový kód",
	requestingBtn: "Probíhá požadování...",
	requestSuccess: "Na váš e-mail byl odeslán kód",
	requestAgain: "Požádat znovu za {seconds}s",
	tfaError: "Heslo musí mít délku 6 - 10 znaků.",
	back: "Přejít zpět"
};
var signupCard = {
	title: "Registrovat",
	lead: "Vytvořit účet <id>Streamlabs ID</id> pro používání <company>{company}</company>",
	successText: "Povedlo se! Přesměrovávání..."
};
var signupSourcesCard = {
	title: "Registrovat",
	lead: "Vytvořit účet <id>Streamlabs ID</id> pro používání <company>{company}</company>",
	withSlId: "Vytvořit Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Zvolit účet",
		lead: "a pokračovat na <b>{company}</b>",
		authorize: "Ověřit",
		authorizeSuccess: "Povedlo se!",
		cancel: "Zrušit",
		disclaimer: {
			streamlabs: "Pokračováním budete sdílet své ID Streamlabs (jméno, e-mailovou adresu, jazykové preference a profilový obrázek) s <b>{company}</b>. Autorizací účtu s <b>{company}</b> souhlasíte se <privacy>zásadami ochrany osobních údajů</privacy> a <terms>podmínkami služby</terms> <b>{company}</b>.",
			"default": "Aby bylo možné pokračovat, bude Streamlabs sdílet vaše jméno, e-mailovou adresu, jazykové preference a profilový obrázek s <b>{company}</b>. Autorizací účtu s <b>{company}</b> souhlasíte se <privacy>zásadami ochrany osobních údajů</privacy> a <terms>podmínkami služby</terms> <b>{company}</b>."
		},
		emailRequired: "Před pokračováním je vyžadováno ověření e-mailu",
		tfaRequired: "Před pokračováním je vyžadováno dvoufaktorové ověření"
	},
	login: {
		title: "Přihlásit se k {company}",
		lead: "Aby se bylo možné připojovat k účtům, musíte být přihlášeni",
		loginBtn: "Přejít na přihlášení"
	},
	error: {
		title: "Přihlásit se k {company}",
		lead: "Váš požadavek nyní nebylo možné ověřit.",
		verifyEmail: "Ověření e-mailu",
		verify2fa: "2faktorové ověření"
	},
	"switch": {
		btn: "Použít jiný účet"
	}
};
var appsDropdown = {
	label: "Produkty a aplikace Streamlabs",
	viewMore: "Rozbalit",
	viewLess: "Sbalit"
};
var platformButtons = {
	loginWithPlatform: "Přihlásit se pomocí platformy",
	signUpWithPlatform: "Zaregistrovat se pomocí platformy",
	signUpLead: "Podporujeme živé streamování na mnoho dalších platforem. Zde uvedené platformy slouží jako možnosti registrace."
};
var ultraCheckoutCard = {
	title: "Povyšte své živé streamy, značku, editaci a další na novou úroveň se <b>Streamlabs Ultra</b>",
	badge: "Zahrnuje <b>{planName}</b>",
	totalValue: "{price, currency} hodnota",
	price: {
		month: "{price, currency}/měs.",
		year: "{price, currency}/rok"
	},
	description: {
		month: "Získejte přístup k prémiovým funkcím z kompletní sady, např. <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> a další, dostupným za jedinou konečnou cenu.",
		year: "Získejte přístup k prémiovým funkcím z kompletní sady, např. <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> a další, dostupným za jedinou konečnou cenu."
	},
	seeIncluded: "Další informace",
	buyNow: "Provést upgrade"
};
var ultraCheckoutBanner = {
	title: "Povyšte své živé streamy, značku, editaci a další na novou úroveň se <b>Streamlabs Ultra</b>",
	badge: "Zahrnuje <b>{planName}</b>",
	totalValue: "{price, currency} hodnota",
	price: {
		month: "{price, currency}/měs.",
		year: "{price, currency}/rok"
	},
	description: {
		month: "Získejte přístup k prémiovým funkcím z kompletní sady, např. <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> a další, dostupným za jedinou konečnou cenu. <link />",
		year: "Získejte přístup k prémiovým funkcím z kompletní sady, např. <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> a další, dostupným za jedinou konečnou cenu. <link />"
	},
	seeIncluded: "Další informace",
	buyNow: "Provést upgrade"
};
var connect = {
	waitMessage: "Slučování dat. Toto okno nezavírejte."
};
var verifyPasswordCard = {
	success: "Heslo bylo úspěšně ověřeno",
	title: "Pro ověření se znovu přihlaste",
	lead: "Pro pokračování v aktualizaci vašeho Streamlabs ID se přihlaste pomocí svého stávajícího e-mailu a hesla.",
	buttonText: "Další"
};
var emailChangeForm = {
	agreeError: "Potvrďte, že rozumíte této aktivitě",
	buttonText: "Další",
	emailPlaceholder: "Nová e-mailová adresa",
	agreeText: "Rozumím, že po ověření se mé Streamlabs ID změní u všech produktů Streamlabs, se kterými je spojeno."
};
var verifyNewEmailCard = {
	title: "Změňte své Streamlabs ID",
	lead: "Uveďte nový e-mail pro použití s vaším Streamlabs ID. Na tuto adresu zašleme 6–8místný ověřovací kód.",
	successText: "Nový e-mail k dispozici"
};
var verifyNewEmailOwnershipCard = {
	title: "Ověřte své aktualizované Streamlabs ID",
	lead: "Ve vašem e-mailu vyhledejte 8místný kód od Streamlabs a zadejte jej níže.",
	buttonText: "Potvrdit",
	back: "Zpět",
	codePlaceholder: "8místný kód z e-mailu",
	successText: "Vlastnictví e-mailu bylo úspěšně ověřeno"
};
var verifyTfaCard = {
	title: "Kód dvoufaktorového ověření",
	lead: "Zadejte 6místný ověřovací kód z vaší aplikace pro ověřování.",
	codePlaceholder: "6místný kód",
	buttonText: "Potvrdit",
	successText: "Dvoufaktorové ověřování potvrzeno",
	back: "Zpět"
};
var ageGateForm = {
	ageLabel: "Datum narození",
	agePlaceholder: "MM/DD/RRRR"
};
var ageGateCard = {
	title: "Dokončete nastavení účtu",
	lead: {
		years: "Pro vytvoření účtu vám musí být {years} nebo více let. <br />Pro dokončení nastavení zadejte své datum narození.",
		noYears: "Pro vytvoření účtu musíte uvést své datum narození. <br />Zadejte jej a dokončete nastavení."
	},
	successText: "Blahopřejeme! Nastavení účtu bylo dokončeno."
};
var csCZ = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { csCZ as c };
//# sourceMappingURL=cs-CZ.es.js.map
